import { generateUUID } from './uuid.js';
function getErrorObject(message, details) {
    return { details, message: `[Load script]: ${message}` };
}
function loadScript(options) {
    const loadScriptPromise = new Promise((resolve, reject) => {
        const { identifier, src } = options;
        const existingScriptElements = document.head.getElementsByTagName('script');
        const exists = Array.from(existingScriptElements).find((element) => {
            return element.getAttribute('identifier') === identifier;
        });
        if (exists) {
            if (exists.getAttribute('src') !== src || options.forceReload) {
                exists.remove();
            }
            else {
                return reject(getErrorObject('Another script tag with the same src attribute already exists'));
            }
        }
        const tag = document.createElement('script');
        if (options.async) {
            tag.async = options.async;
        }
        if (options.defer) {
            tag.defer = options.defer;
        }
        tag.src = src;
        const nonce = window.btoa(generateUUID());
        tag.setAttribute('identifier', identifier);
        tag.setAttribute('nonce', nonce); // needs to be base64
        tag.onerror = (error) => reject(getErrorObject('Failed to load script', error));
        tag.onload = () => resolve(tag);
        document.head.appendChild(tag);
    });
    return loadScriptPromise;
}
export { loadScript, };
//# sourceMappingURL=load-script.js.map